//
import { getFetchDataFunction } from '../DataTableService'

//
import ProductAppends from './ProductAppends'
import ProductIncludes from './ProductIncludes'

//
const route = process.env.VUE_APP_API_ROUTE.concat(
    '/wh_product?filter[type]=item'
)

//
export default getFetchDataFunction(route, ProductIncludes, ProductAppends)
